import React from 'react';
import {NumberFormat} from 'components';

export function InlineNumberFormat({ className, value, unit }) {
  const isCurrency = /^\$|£|€$/.test(unit);
  return (Boolean(value) || typeof value == 'number') && (
    <span className={className}>
      <NumberFormat
        prefix={isCurrency && unit}
        value={isCurrency ? parseFloat(value).toFixed(2) : value}
        displayType="text"
        thousandSeparator
      />
      { !isCurrency && unit &&
        <small> { unit }</small>
      }
    </span>
  );
}
